export default "__VITE_ASSET__BCmfuI3L__"